export const API_URI = "https://my-json-server.typicode.com/SahilMund/ecarts/products";